import { ThreeComponet } from './types'
import * as THREE from 'three'
import { MathEx } from '@ykob/js-util'
import vertexShader from './glsl/ground.vs'
import fragmentShader from './glsl/ground.fs'

interface GroundUniforms {
  time: THREE.IUniform<number>
  [uniform: string]: THREE.IUniform<any>
}

export default class Ground extends ThreeComponet<GroundUniforms> {
  constructor() {
    super({
      time: {
        // type: 'f',
        value: 0,
      },
    })
  }

  createObj(): THREE.Mesh {
    const mesh = new THREE.Mesh(
      new THREE.PlaneGeometry(1024, 1024, 32, 32),
      new THREE.RawShaderMaterial({
        uniforms: this.uniforms,
        vertexShader,
        fragmentShader,
        transparent: true,
        wireframe: true,
      })
    )
    mesh.position.set(0, -200, 0)
    mesh.rotation.set(MathEx.radians(-90), 0, 0)
    return mesh
  }

  render(time: number): void {
    this.uniforms.time.value += time
  }
}
